import joi from 'joi';
import {
  ChannelInfo,
  RewardI18nAttributes,
  RewardState,
  RewardType,
} from '../../rewards-api-client';

export interface PromoCodeAttribution {
  rewardId: string;
  promocode: string;
  promocodeId?: string;
  profileVersion: number;
}

export enum TransactionType {
  EARN = 'EARN',
  BURN = 'BURN',
  MANUAL = 'MANUAL',
  EXPIRATION = 'EXPIRATION',
}

export interface TransactionI18nAttributes {
  [language: string]: {
    description: string;
  };
}

export interface ProfileRewardData {
  channelInfoByLanguage?: { [language: string]: ChannelInfo };
  campaignId?: string;
  giftId?: number;
}

export interface TransactionAttributes {
  id: string;
  accountId: string;
  programId: string;
  profileId: string;
  profileNumericalId: number;
  ruleId: string | null;
  type: TransactionType;
  eventId: string;
  i18nAttributes: TransactionI18nAttributes | null;
  currencyId: string;
  amount: number;
  absoluteAmount: number;
  quantityUsed: number;
  available: boolean;
  eventTimestamp: string;
  data?: ProfileRewardData;
  createdAt: string;
  updatedAt?: string;
  expirationDate?: string | null;
  expired: boolean;
}

export interface ProfileRewardAttributes {
  id: string;
  accountId: string;
  programId: string;
  profileVersion: number;
  state: RewardState;
  ruleId?: string | null;
  amount: number;
  currencyId?: string | null;
  type: RewardType;
  expirationDate?: string;
  rewardId: string;
  promocode?: string | null;
  promocodeId?: string | null;
  i18nAttributes: RewardI18nAttributes;
  data?: ProfileRewardData | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface AssignPromoCodePayload {
  rewardId: string;
  promocodeId: string;
  promocode: string;
  profileVersion: number;
}

export const $assignRewardPayload = joi.object({
  rewardId: joi.string(),
  promocodeId: joi.string(),
  promocode: joi.string(),
  profileVersion: joi.number(),
});
